import React from "react";
import "./hiera.scss";
import data from "../../data.json";
import Heroc from "../../../component/hero/heroc.jsx";
import Aboutc from "../../../component/about/aboutc.jsx";
import Heroimages from "../../../asset/hero/heroimages.js";
import Promoc from "../../../component/promo/promoc.jsx";
import hsimages from "../../../asset/hardsell/hsimages.js";
import prmo from "../../../component/promo/promocard.json";
import Carouselfasc from "../../../component/carouselfas/carouselfasc.jsx";
import fas from "../../../component/carouselfas/carouselfasc.json";
import fashiera from "../../../asset/fascarousel/fas-hiera/fas-hiera.js";
import dataproduk from "../../../component/cardprodukdetail/cardprodukdetail.json";
import imgWelton7 from "../../../asset/imgrumah/img-hiera/img-welton/img-welton7/img-welton7.js";
import imgWelton8 from "../../../asset/imgrumah/img-hiera/img-welton/img-welton8/img-welton8.js";
import imgWelton9 from "../../../asset/imgrumah/img-hiera/img-welton/img-welton9/img-welton9.js";
import imgWynyard7 from "../../../asset/imgrumah/img-hiera/img-wynyard/img-wynyard7/img-wynyard7.js";
import imgWynyard8 from "../../../asset/imgrumah/img-hiera/img-wynyard/img-wynyard8/img-wynyard8.js";
import imgWynyard9 from "../../../asset/imgrumah/img-hiera/img-wynyard/img-wynyard9/img-wynyard9.js";
import Cardprodukdetail from "../../../component/cardprodukdetail/cardprodukdetail.jsx";
import ScrollToHashElement from "../../home/ScrollToHashElement.js";
import Cardprodukdetail1 from "../../../component/cardprodukdetail/cardprodukdetail1.jsx";
const imgMap = {
  fashiera,
};
const imageMap = {
  imgWelton7,
  imgWelton8,
  imgWelton9,
  imgWynyard7,
  imgWynyard8,
  imgWynyard9,
};

const hiera = () => {
  return (
    <div className="hiera">
      <ScrollToHashElement />
      <div className="hero">
        {data.hieraab.map((hero, index) => {
          // Determine the logo dynamically
          const fotopromo = Heroimages[hero.imagehero];
          return (
            <Heroc
              key={index}
              imagehero={fotopromo} // Dynamically import logo images // Pass the WhatsApp link
            />
          );
        })}
      </div>
      <div className="about">
        {data.hieraab.map((home, index) => {
          // Determine the logo dynamically
          return (
            <Aboutc
              key={index}
              judul={home.judul}
              subjudul={home.subjudul} // Dynamically import logo images // Pass the WhatsApp link
            />
          );
        })}
      </div>
      <div className="container-promo">
        {prmo.Hiera.map((promo, index) => {
          // Determine the logo dynamically
          const fotopromo = hsimages[promo.imagehs];
          return (
            <Promoc
              key={index}
              imagehs={fotopromo} // Dynamically import logo images
              titlepromo={promo.titlepromo}
              details={promo.details}
              whatsappLink={promo.whatsappLink}
              quote={promo.quote} // Pass the WhatsApp link
            />
          );
        })}
      </div>
      <div className="carouselfas">
        {fas.fasHiera.map((slide, index) => {
          return <Carouselfasc key={index} carousel={imgMap[slide.carousel]} />;
        })}
      </div>
      <div id="welton" className="devider">
        <div className="a">WELTON</div>
      </div>
      <div className="produkcontainer">
        {dataproduk.Weltonp.map((card, index) => {
          return (
            <Cardprodukdetail
              key={index}
              src={imageMap[card.imagesKey]}
              title={card.title}
              sub={card.sub}
              subt={card.subt}
              details={card.details}
              price={card.price}
              whatsappLink={card.whatsappLink}
            />
          );
        })}
      </div>
      <div id="wynyard" className="devider">
        <div className="a">WYNYARD</div>
      </div>
      <div className="produkcontainer">
        {dataproduk.Wynyardp.map((card, index) => {
          return (
            <Cardprodukdetail1
              key={index}
              src={imageMap[card.imagesKey]}
              title={card.title}
              sub={card.sub}
              subt={card.subt}
              details={card.details}
              price={card.price}
              whatsappLink={card.whatsappLink}
            />
          );
        })}
      </div>
    </div>
  );
};

export default hiera;
